/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Referral
 */
export interface Referral {
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    referrerId: string;
    /**
     * 
     * @type {string}
     * @memberof Referral
     */
    referrerEmail: string;
    /**
     * 
     * @type {number}
     * @memberof Referral
     */
    count?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Referral
     */
    referredUsers: Array<string>;
}

/**
 * Check if a given object implements the Referral interface.
 */
export function instanceOfReferral(value: object): value is Referral {
    if (!('referrerId' in value) || value['referrerId'] === undefined) return false;
    if (!('referrerEmail' in value) || value['referrerEmail'] === undefined) return false;
    if (!('referredUsers' in value) || value['referredUsers'] === undefined) return false;
    return true;
}

export function ReferralFromJSON(json: any): Referral {
    return ReferralFromJSONTyped(json, false);
}

export function ReferralFromJSONTyped(json: any, ignoreDiscriminator: boolean): Referral {
    if (json == null) {
        return json;
    }
    return {
        
        'referrerId': json['referrerId'],
        'referrerEmail': json['referrerEmail'],
        'count': json['count'] == null ? undefined : json['count'],
        'referredUsers': json['referredUsers'],
    };
}

export function ReferralToJSON(json: any): Referral {
    return ReferralToJSONTyped(json, false);
}

export function ReferralToJSONTyped(value?: Referral | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referrerId': value['referrerId'],
        'referrerEmail': value['referrerEmail'],
        'count': value['count'],
        'referredUsers': value['referredUsers'],
    };
}

